import { useMemo } from "react";

import { CommunicationsUIStateInbox } from "@/Common/Models/UI/Enums";
import { PortalCommunicationFilterSettingsType, PortalCommunicationInboxFilterSetting, PortalCommunicationSentFilterSetting } from "@/Communications/Models/PortalCommunication/PortalCommunicationFilterSettings";

export function usePortalCommunicationFilterSetting(inboxType: CommunicationsUIStateInbox): {
    currentFilterSetting: PortalCommunicationFilterSettingsType;
} {
    const currentFilterSetting = useMemo(() => {
        switch (inboxType) {
            case CommunicationsUIStateInbox.Sent:
                return (
                    PortalCommunicationSentFilterSetting.fromResponseModel(
                        cacheStore.UserSettings.PortalCommunicationSentFilterSetting
                    ) ?? new PortalCommunicationSentFilterSetting()
                );

            case CommunicationsUIStateInbox.FlaggedForReview:
                return (
                    PortalCommunicationInboxFilterSetting.fromResponseModel(
                        cacheStore.UserSettings.PortalCommunicationFlaggedFilterSetting
                    ) ?? new PortalCommunicationInboxFilterSetting()
                );

            case CommunicationsUIStateInbox.Archive:
                return (
                    PortalCommunicationInboxFilterSetting.fromResponseModel(
                        cacheStore.UserSettings.PortalCommunicationArchivedFilterSetting
                    ) ?? new PortalCommunicationInboxFilterSetting()
                );

            case CommunicationsUIStateInbox.Inbox:
                return (
                    PortalCommunicationInboxFilterSetting.fromResponseModel(
                        cacheStore.UserSettings.PortalCommunicationInboxFilterSetting
                    ) ?? new PortalCommunicationInboxFilterSetting()
                );

            default:
                return new PortalCommunicationInboxFilterSetting();
        }
    }, [inboxType]);

    return { currentFilterSetting };
}
